import { render, staticRenderFns } from "./CalendarListItemSharingPublishItem.vue?vue&type=template&id=11482ace&"
import script from "./CalendarListItemSharingPublishItem.vue?vue&type=script&lang=js&"
export * from "./CalendarListItemSharingPublishItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11482ace')) {
      api.createRecord('11482ace', component.options)
    } else {
      api.reload('11482ace', component.options)
    }
    module.hot.accept("./CalendarListItemSharingPublishItem.vue?vue&type=template&id=11482ace&", function () {
      api.rerender('11482ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/CalendarListItemSharingPublishItem.vue"
export default component.exports